// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T6RH","fullView":"styles_fullView__1CvPn"};